<div class="admin-extend-wrapper">
  <!-- ════ TOP BREADCRUMB & BACK ════ -->
  <div class="top-nav-bar">
    <app-back-button></app-back-button>
    <div class="top-nav-breadcrumbs">
      <a routerLink="/admin/campanhas">Campanhas</a>
      <i class="fas fa-chevron-right"></i>
      <span>Detalhes da Campanha #{{ campanha?.id }}</span>
    </div>
  </div>

  <ng-container *ngIf="loading; else setData">
    <app-skeleton-loader [count]="1" type="detalhe-campanha"></app-skeleton-loader>
  </ng-container>

  <ng-template #setData>
    <ng-container *ngIf="campanha; else Nodata">
      <!-- ════ MAIN BANNER / HEADER CARD ════ -->
      <div class="admin-campanha-header-card">
        <div class="header-main-content">
          <h1 class="header-title">{{ campanha?.titulo || "Sem título informado" }}</h1>

          <div class="header-badges">
            <span class="badge-tag sector">
              <i class="fas fa-tag"></i>
              {{ campanha?.categoria?.descricao || "Geral" }}
            </span>
            <span class="badge-tag location">
              <i class="fas fa-map-marker-alt"></i>
              {{ campanha?.provincia?.descricao || "Angola" }}
            </span>
            <span class="badge-tag type">
              <i class="fas fa-hand-holding-dollar"></i>
              {{ campanha?.tipoFinanciamento || "Financiamento Colectivo" }}
            </span>
            <span class="status-pill" [attr.data-status]="campanha?.estadoCampanha || campanha?.estado">
              {{ campanha?.estadoCampanha || campanha?.estado }}
            </span>
          </div>

          <div class="header-meta-row">
            <div class="meta-item">
              <i class="fas fa-user-circle"></i>
              <span>Criado por <strong>{{ campanha?.utilizadorNome || "Autor não informado" }}</strong></span>
            </div>
            <div class="meta-item">
              <i class="fas fa-calendar-alt"></i>
              <span>Criada em: <strong>{{ campanha?.dataCriacaoFormatada || (campanha?.dataCriacao | date: 'dd/MM/yyyy')
                  }}</strong></span>
            </div>
            <div class="meta-item" *ngIf="campanha?.dataTerminoFormatada || campanha?.dataTermino">
              <i class="fas fa-clock"></i>
              <span>Término: <strong>{{ campanha?.dataTerminoFormatada || (campanha?.dataTermino | date: 'dd/MM/yyyy')
                  }}</strong></span>
            </div>
          </div>
        </div>

        <!-- Botões de Ação Administrativa no Topo -->
        <div class="header-actions-panel">
          <button type="button" class="admin-btn btn-publish" (click)="publicarCampanha()"
            *ngIf="campanha?.estadoCampanhaENUM === 2 || campanha?.estadoCampanhaENUM === 5" [disabled]="loading">
            <i class="fas fa-circle-check"></i>
            <span>{{ loading ? "Publicando..." : "Publicar Campanha" }}</span>
          </button>

          <button type="button" class="admin-btn btn-reject" (click)="showdialogRejeit()"
            *ngIf="campanha?.estadoCampanhaENUM === 2" [disabled]="loadingRejeit">
            <i class="fas fa-circle-xmark"></i>
            <span>{{ loadingRejeit ? "Recusando..." : "Recusar Campanha" }}</span>
          </button>

          <button type="button" class="admin-btn btn-suspend" (click)="suspenderCampanha(campanha)"
            *ngIf="campanha?.estadoCampanhaENUM === 4 || campanha?.estadoCampanhaENUM === 3"
            [disabled]="loadingSuspend">
            <i class="fas fa-ban"></i>
            <span>{{ loadingSuspend ? "Suspendendo..." : "Suspender Campanha" }}</span>
          </button>

          <button type="button" class="admin-btn btn-attach" (click)="abrirModalMidia()"
            *ngIf="!docPreview || !imgPreview || (!vidPreview && !linkVideo)">
            <i class="fas fa-paperclip"></i>
            <span>Adicionar Anexos</span>
          </button>
        </div>
      </div>

      <!-- ════ 2-COLUMN ADMIN GRID ════ -->
      <div class="admin-detail-layout">
        <!-- ── LEFT COLUMN: MÍDIA, DESCRIÇÃO E ANEXOS ── -->
        <div class="admin-left-col">
          <!-- Mídia Player Card -->
          <div class="content-card media-card">
            <div class="card-header-row">
              <h3 class="card-heading">
                <i class="fas fa-photo-film text-primary mr-2"></i> Mídia de Apresentação
              </h3>
            </div>

            <div class="media-container custom-player-wrapper" (mouseenter)="showOverlay()" (mouseleave)="hideOverlay()"
              (mousemove)="resetOverlayTimeout()">
              <ng-container *ngIf="vidPreview; else showLinkVideo">
                <video #nativeVideo [src]="vidPreview" [muted]="isMuted" class="media-video"
                  (timeupdate)="onNativeTimeUpdate()" (loadedmetadata)="onNativeLoadedMetadata()"
                  (play)="onNativePlayStateChange(true)" (pause)="onNativePlayStateChange(false)"></video>
              </ng-container>

              <ng-template #showLinkVideo>
                <ng-container *ngIf="linkVideo; else showImage">
                  <iframe #youtubePlayerIframe id="yt-player" [src]="linkVideo | safeUrl" frameborder="0"
                    class="media-iframe" allow="autoplay; encrypted-media" allowfullscreen></iframe>
                </ng-container>
              </ng-template>

              <ng-template #showImage>
                <img [src]="imgPreview || '/images/campanha-1.png'" [alt]="campanha?.titulo || 'Imagem da campanha'"
                  class="media-img" />
              </ng-template>

              <!-- Video Controls Overlay -->
              <div *ngIf="vidPreview || linkVideo" class="video-controls-overlay"
                [class.visible]="isOverlayVisible || !isPlaying" (click)="onOverlayClick($event)">
                <div class="video-header">
                  <h4 class="video-title">{{ campanha?.titulo || "Vídeo da Campanha" }}</h4>
                </div>
                <div class="video-center-btn">
                  <button type="button" class="play-pause-btn" (click)="togglePlay(); $event.stopPropagation()">
                    <i [class]="isPlaying ? 'fas fa-pause' : 'fas fa-play'"></i>
                  </button>
                </div>
                <div class="video-footer">
                  <div class="progress-container" (click)="seekVideo($event)">
                    <div class="progress-bar-fill" [style.width.%]="progressPercent"></div>
                  </div>
                  <div class="controls-row">
                    <span class="time-display">{{ formatTime(currentTime) }} / {{ formatTime(duration) }}</span>
                    <div class="volume-container" (click)="$event.stopPropagation()">
                      <button type="button" class="volume-btn" (click)="toggleMute()">
                        <i
                          [class]="isMuted ? 'fas fa-volume-xmark' : (volume > 50 ? 'fas fa-volume-high' : 'fas fa-volume-low')"></i>
                      </button>
                      <input type="range" min="0" max="100" [value]="isMuted ? 0 : volume"
                        (input)="onVolumeChange($event)" class="volume-slider" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Descrição Completa Card -->
          <div class="content-card description-card">
            <div class="card-header-row">
              <h3 class="card-heading">
                <i class="fas fa-align-left text-primary mr-2"></i> Descrição da Campanha
              </h3>
            </div>

            <div class="description-body">
              <div class="lead-summary" *ngIf="campanha?.descricaoCurta">
                <strong>Resumo:</strong> {{ campanha?.descricaoCurta }}
              </div>
              <div class="main-text" [innerHTML]="campanha?.descricao || 'Sem descrição informada.'"></div>
            </div>

            <!-- Redes Sociais do Projeto -->
            <div class="social-channels-block" *ngIf="campanha?.redesSociaisList?.length">
              <h4 class="sub-heading">Redes e Ligações Externas</h4>
              <div class="social-links-grid">
                <a *ngFor="let url of campanha?.redesSociaisList" [href]="url" target="_blank" rel="noopener"
                  class="social-pill">
                  <i [class]="url | socialIcon"></i>
                  <span>{{ url | trimText: 40 }}</span>
                  <i class="fas fa-arrow-up-right-from-square text-xs ml-auto"></i>
                </a>
              </div>
            </div>
          </div>

          <!-- Recompensas da Campanha Card -->
          <div class="content-card rewards-card" *ngIf="isCampanhaRecompensa() && campanha?.recompensa?.length">
            <div class="card-header-row">
              <h3 class="card-heading">
                <i class="fas fa-gift text-primary mr-2"></i> Recompensas Cadastradas ({{ campanha?.recompensa?.length || 0 }})
              </h3>
              <span class="badge-total-rewards">
                <i class="fas fa-coins mr-1"></i> Total Previsto: <strong>{{ getSomaRecompensas() | money }} Kz</strong>
              </span>
            </div>

            <div class="admin-extend-rewards-grid mt-4">
              <div class="extend-reward-card" *ngFor="let rec of campanha.recompensa; let i = index">
                <div class="erc-header">
                  <span class="erc-index">#{{ i + 1 }}</span>
                  <span class="erc-type" *ngIf="rec.tipoRecompensa">{{ rec.tipoRecompensa }}</span>
                  <span class="erc-value">{{ rec.valor | money }} Kz</span>
                </div>
                <h4 class="erc-title">{{ rec.titulo }}</h4>
                <p class="erc-desc">{{ rec.descricao }}</p>
                <div class="erc-footer">
                  <div class="erc-stat">
                    <i class="fas fa-boxes-stacked"></i>
                    <span>Quantidade: <strong>{{ rec.quantidade }}</strong> (Disponíveis: {{ rec.quantidadeDisponivel ?? rec.quantidade }})</span>
                  </div>
                  <div class="erc-stat" *ngIf="rec.dataIncioRecompensa || rec.dataInicioRecompensa">
                    <i class="fas fa-calendar-alt"></i>
                    <span>Vigência: {{ (rec.dataIncioRecompensaFormatada || rec.dataIncioRecompensa || rec.dataInicioRecompensa) | date: 'dd/MM/yyyy' }} até {{ (rec.dataTerminoRecompensaFormatada || rec.dataTerminoRecompensa) | date: 'dd/MM/yyyy' }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Documentos & Anexos Card -->
          <div class="content-card attachments-card">
            <div class="card-header-row">
              <h3 class="card-heading">
                <i class="fas fa-folder-open text-primary mr-2"></i> Documentos e Ficheiros Submetidos
              </h3>
            </div>

            <div class="attachments-list" *ngIf="docPreview || imgPreview || linkVideo; else noFilesFound">
              <!-- Documento PDF -->
              <div class="file-item-card" *ngIf="docPreview && docInfo" (click)="abrirDoc()">
                <div class="file-icon-box pdf">
                  <i class="fas fa-file-pdf"></i>
                </div>
                <div class="file-info-col">
                  <div class="file-name">{{ docInfo?.nome }}</div>
                  <div class="file-meta">{{ docInfo?.tamanho }} · {{ docInfo?.tipo }}</div>
                </div>
                <button type="button" class="file-btn" (click)="$event.stopPropagation(); abrirDoc()"
                  title="Visualizar Documento">
                  <i class="fas fa-eye"></i> Visualizar
                </button>
              </div>

              <!-- Imagem da Campanha -->
              <div class="file-item-card" *ngIf="imgPreview && imgInfo" (click)="abrirImagem()">
                <div class="file-icon-box image">
                  <i class="fas fa-file-image"></i>
                </div>
                <div class="file-info-col">
                  <div class="file-name">{{ imgInfo?.nome }}</div>
                  <div class="file-meta">{{ imgInfo?.tamanho }} · {{ imgInfo?.tipo }}</div>
                </div>
                <button type="button" class="file-btn" (click)="$event.stopPropagation(); abrirImagem()"
                  title="Visualizar Imagem">
                  <i class="fas fa-eye"></i> Visualizar
                </button>
              </div>

              <!-- Vídeo Externo / Link -->
              <div class="file-item-card" *ngIf="linkVideo" (click)="abrirVideoLink(rawVideoUrl || linkVideo)">
                <div class="file-icon-box video">
                  <i class="fab fa-youtube"></i>
                </div>
                <div class="file-info-col">
                  <div class="file-name">Vídeo de Apresentação Oficial</div>
                  <div class="file-meta">{{ (rawVideoUrl || linkVideo) | trimText: 45 }}</div>
                </div>
                <button type="button" class="file-btn" (click)="abrirLinkExterno(rawVideoUrl || linkVideo, $event)">
                  <i class="fas fa-external-link-alt"></i> Abrir Link
                </button>
              </div>
            </div>

            <ng-template #noFilesFound>
              <div class="no-files-notice">
                <i class="fas fa-inbox text-2xl text-slate-400 mb-2"></i>
                <p>Nenhum documento ou comprovativo foi anexado a esta campanha.</p>
              </div>
            </ng-template>
          </div>
        </div>

        <!-- ── RIGHT COLUMN: AUDITORIA, PROGRESSO & CRIADOR ── -->
        <div class="admin-right-col">
          <!-- Progresso Financeiro Card -->
          <div class="content-card progress-card">
            <div class="card-header-row">
              <h3 class="card-heading">
                <i class="fas fa-chart-line text-primary mr-2"></i> Desempenho Financeiro
              </h3>
            </div>

            <div class="progress-metric-box">
              <div class="metric-top-row">
                <div>
                  <span class="metric-label">Valor Arrecadado</span>
                  <div class="metric-val text-green-700">
                    {{ (campanha?.valorArrecado || 0) | money }} Kz
                  </div>
                </div>
                <div class="metric-pct-box">
                  {{ getPercent(campanha) }}%
                </div>
              </div>

              <div class="fp-track">
                <div class="fp-fill" [style.width.%]="getPercent(campanha) > 100 ? 100 : getPercent(campanha)"></div>
              </div>

              <div class="metric-bottom-row">
                <span>Meta: <strong>{{ (campanha?.metaArrecadar || 0) | money }} Kz</strong></span>
                <span *ngIf="campanha?.diasRestantes">Faltam <strong>{{ campanha?.diasRestantes }} dias</strong></span>
              </div>
            </div>

            <div class="stats-mini-grid">
              <div class="stat-mini-box">
                <div class="stat-icon"><i class="fas fa-users text-blue-600"></i></div>
                <div class="stat-info">
                  <span class="stat-num">{{ campanha?.totalApoiantes || 0 }}</span>
                  <span class="stat-txt">Doadores</span>
                </div>
              </div>

              <div class="stat-mini-box">
                <div class="stat-icon"><i class="fas fa-heart text-red-500"></i></div>
                <div class="stat-info">
                  <span class="stat-num">{{ campanha?.curtidas?.totalCurtidas || 0 }}</span>
                  <span class="stat-txt">Curtidas</span>
                </div>
              </div>

              <div class="stat-mini-box">
                <div class="stat-icon"><i class="fas fa-comments text-amber-500"></i></div>
                <div class="stat-info">
                  <span class="stat-num">{{ campanha?.totalComentarios || 0 }}</span>
                  <span class="stat-txt">Comentários</span>
                </div>
              </div>

              <div class="stat-mini-box">
                <div class="stat-icon"><i class="fas fa-shield-halved text-purple-600"></i></div>
                <div class="stat-info">
                  <span class="stat-num">{{ campanha?.estadoCampanha || campanha?.estado }}</span>
                  <span class="stat-txt">Estado Atual</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Informações do Criador Card -->
          <div class="content-card creator-card">
            <div class="card-header-row">
              <h3 class="card-heading">
                <i class="fas fa-id-card text-primary mr-2"></i> Dados do Criador
              </h3>
            </div>

            <div class="creator-profile-header">
              <div class="creator-avatar-badge">
                {{ (campanha?.utilizadorNome ? campanha?.utilizadorNome[0] : 'U') | uppercase }}
              </div>
              <div class="creator-profile-info">
                <h4 class="creator-name">{{ campanha?.utilizadorNome || "Autor da Campanha" }}</h4>
                <span class="creator-tag verified">
                  <i class="fas fa-circle-check text-green-600"></i> Identidade Verificada
                </span>
              </div>
            </div>

            <div class="creator-details-list">
              <div class="creator-detail-row">
                <span class="dt-label"><i class="fas fa-envelope mr-2 text-slate-400"></i> Email</span>
                <span class="dt-val">{{ campanha?.utilizadorEmail || "Não informado" }}</span>
              </div>
              <div class="creator-detail-row">
                <span class="dt-label"><i class="fas fa-phone mr-2 text-slate-400"></i> Contacto</span>
                <span class="dt-val">{{ campanha?.utilizadorTelefone || "Não informado" }}</span>
              </div>
              <div class="creator-detail-row">
                <span class="dt-label"><i class="fas fa-building-columns mr-2 text-slate-400"></i> IBAN de
                  Repasse</span>
                <span class="dt-val iban-highlight">{{ campanha?.utilizadorIban || "Não configurado" }}</span>
              </div>
            </div>
          </div>

          <!-- Painel de Prazos e Auditoria -->
          <div class="content-card audit-card">
            <div class="card-header-row">
              <h3 class="card-heading">
                <i class="fas fa-history text-primary mr-2"></i> Prazos e Datas
              </h3>
            </div>

            <div class="timeline-audit">
              <div class="audit-step">
                <div class="audit-dot green"></div>
                <div class="audit-info">
                  <div class="audit-title">Submissão da Campanha</div>
                  <div class="audit-date">{{ campanha?.dataCriacaoFormatada || (campanha?.dataCriacao | date:
                    'dd/MM/yyyy HH:mm') }}</div>
                </div>
              </div>

              <div class="audit-step">
                <div class="audit-dot" [class.green]="campanha?.dataInicio" [class.amber]="!campanha?.dataInicio"></div>
                <div class="audit-info">
                  <div class="audit-title">Aprovação / Início</div>
                  <div class="audit-date">{{ campanha?.dataInicioFormatada || (campanha?.dataInicio | date:
                    'dd/MM/yyyy') || "Pendente" }}</div>
                </div>
              </div>

              <div class="audit-step">
                <div class="audit-dot" [class.red]="campanha?.estadoCampanhaENUM === 6"
                  [class.slate]="campanha?.estadoCampanhaENUM !== 6"></div>
                <div class="audit-info">
                  <div class="audit-title">Data Limite de Angariação</div>
                  <div class="audit-date">{{ campanha?.dataTerminoFormatada || (campanha?.dataTermino | date:
                    'dd/MM/yyyy') || "A definir" }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-template>

  <ng-template #Nodata>
    <div class="no-data-card">
      <app-data-void titulo="Campanha não encontrada"
        descricao="Esta campanha não foi encontrada ou foi removida."></app-data-void>
    </div>
  </ng-template>
</div>

<!-- ════ MODAIS ADMINISTRATIVOS ════ -->
<app-supender-campanha [campanhaID]="campanhaID" [visible]="showDialogSuspend" (onClose)="showDialogSuspend = false">
</app-supender-campanha>

<app-rejeitar-campanha [campanhaID]="campanhaID" [visible]="showRejeitCampanha" (onClose)="showRejeitCampanha = false">
</app-rejeitar-campanha>

<!-- Modal Vídeo -->
<p-dialog header="Vídeo da Campanha" [(visible)]="showVideo" [modal]="true"
  [style]="{ width: '90vw', maxWidth: '850px' }" [contentStyle]="{ padding: '0', overflow: 'hidden' }">
  <div class="modal-viewer-container" *ngIf="showVideo">
    <div class="modal-viewer-toolbar" *ngIf="linkVideo">
      <span class="doc-title"><i class="fab fa-youtube text-red-600 mr-2"></i>Vídeo Oficial da Campanha</span>
      <div class="modal-viewer-actions">
        <button type="button" class="btn-toolbar" (click)="abrirLinkExterno(rawVideoUrl || linkVideo, $event)">
          <i class="fas fa-external-link-alt"></i> Abrir no YouTube
        </button>
      </div>
    </div>
    <div class="video-embed-wrap" *ngIf="embedVideoUrl">
      <iframe [src]="embedVideoUrl" frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen class="w-full aspect-video block"></iframe>
    </div>
    <video *ngIf="!embedVideoUrl && vidPreview" [src]="vidPreview" controls width="100%" class="rounded-b-lg"></video>
  </div>
</p-dialog>

<!-- Modal Imagem -->
<p-dialog header="Imagem Oficial" [(visible)]="showImage" [modal]="true"
  [style]="{ width: '85vw', maxWidth: '800px' }" [contentStyle]="{ padding: '0', overflow: 'hidden' }">
  <div class="modal-viewer-container" *ngIf="imgPreview">
    <div class="modal-viewer-toolbar">
      <span class="doc-title">{{ imgInfo?.nome || 'Imagem Oficial' }}</span>
      <div class="modal-viewer-actions">
        <button type="button" class="btn-toolbar" (click)="descarregarFicheiro(imgRawUrl, imgInfo?.nome || 'imagem.jpg', $event)">
          <i class="fas fa-download"></i> Descarregar
        </button>
        <button type="button" class="btn-toolbar" (click)="abrirNovaAba(imgRawUrl, $event)">
          <i class="fas fa-arrow-up-right-from-square"></i> Nova Aba
        </button>
      </div>
    </div>
    <div class="modal-img-wrap">
      <img [src]="imgPreview" alt="Imagem da Campanha" class="max-h-[75vh] w-auto max-w-full rounded-b-lg object-contain mx-auto block" />
    </div>
  </div>
</p-dialog>

<!-- Modal Documento -->
<p-dialog header="Documento em Anexo" [(visible)]="ShowDoc" [modal]="true"
  [style]="{ width: '85vw', maxWidth: '1200px', height: '90vh' }"
  [contentStyle]="{ height: 'calc(90vh - 65px)', padding: '0', overflow: 'hidden' }"
  (onHide)="closeDoc()">
  <div class="modal-viewer-container h-full flex flex-col" *ngIf="docPreview">
    <div class="modal-viewer-toolbar flex-shrink-0">
      <span class="doc-title">{{ docInfo?.nome || 'Documento da Campanha' }}</span>
      <div class="modal-viewer-actions">
        <button type="button" class="btn-toolbar" (click)="descarregarFicheiro(docRawUrl, docInfo?.nome || 'documento.pdf', $event)">
          <i class="fas fa-download"></i> Descarregar PDF
        </button>
        <button type="button" class="btn-toolbar" (click)="abrirNovaAba(docRawUrl, $event)">
          <i class="fas fa-arrow-up-right-from-square"></i> Abrir em Nova Aba
        </button>
      </div>
    </div>
    <div class="modal-iframe-viewer flex-1 w-full h-full">
      <iframe [src]="docPreview" width="100%" height="100%" class="border-0 w-full h-full block"></iframe>
    </div>
  </div>
</p-dialog>

<app-loader *ngIf="loadingMidea"></app-loader>